import mermaid from 'mermaid'
import { useEffect, useRef } from 'react'
import { MermaidConfig } from 'mermaid/dist/config.type'

let uniqueId = 0

export interface MermaidProps {
	graph?: string
	src?: string
	config?: MermaidConfig
	ariaLabel?: string
	className?: string
}

export const Mermaid = ({ graph, src, config, ariaLabel, className }: MermaidProps): JSX.Element => {
	const containerRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const el = containerRef.current
		const text = graph || ''

		if (el && text) {
			mermaid.initialize({
				startOnLoad: false,
				...config,
			})

			let aborted = false

			const renderDiagram = async (): Promise<void> => {
				try {
					el.innerHTML = ''

					const id = `mermaid-${uniqueId++}`
					const { svg, bindFunctions } = await mermaid.render(id, text)

					if (aborted) {
						return
					}

					el.innerHTML = svg

					if (bindFunctions) {
						bindFunctions(el)
					}

					if (ariaLabel) {
						const svgElement = el.querySelector('svg')
						if (svgElement) {
							svgElement.setAttribute('aria-label', ariaLabel)
						}
					}
				} catch (error) {
					console.error('Mermaid rendering failed:', error)
					if (!aborted) {
						el.innerHTML = `<div class="mermaid-error">Diagram rendering failed</div>`
					}
				}
			}

			renderDiagram()

			return () => {
				aborted = true
			}
		}

		return undefined
	}, [graph, src, config, ariaLabel])

	return <div ref={containerRef} className={className} />
}
